import { SnackbarProvider } from "notistack";
import { Slide } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Routers from "./routes";
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/index.css";
import "./assets/css/style.css";
import "./assets/css/chat.css";
import { ContextPGIMode } from "./Hooks/PGIModeContext";
import { Helmet } from "react-helmet-async";
import { s3baseUrl } from "./config/config";
import { useEffect, useState } from "react";
import { ChatContext } from "./Hooks/ChatContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 24 * 60 * 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});

export default function App() {
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [favIcon, setFavIcon] = useState("");

  console.log = () => {};

  useEffect(() => {
    setMetaTitle(localStorage.getItem("metaTitle"));
    setMetaDescription(localStorage.getItem("metaDescription"));
    setFavIcon(localStorage.getItem("favIcon"));
  }, [localStorage]);

  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    };

    document.addEventListener("wheel", handleWheel, { passive: true });

    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  useEffect(() => {
    const handleInput = (e) => {
      if (e.target.type === "number") {
        const value = parseFloat(e.target.value);
        if (value < 0) {
          e.target.value = 0;
        }
      }
    };

    const handleKeyDown = (e) => {
      if (e.target.type === "number") {
        if (e.key === "-" || e.key === "e" || e.key === "E") {
          e.preventDefault();
        }
      }
    };

    document.addEventListener("input", handleInput);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("input", handleInput);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ContextPGIMode>
        <ThemeConfig>
          <GlobalStyles />
          <SnackbarProvider
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            TransitionComponent={Slide}
            maxSnack={3}
            style={{ zIndex: 9999999999 }}
          >
            <Helmet>
              <title>{metaTitle}</title>
              <meta name="description" content={metaDescription} />
              <link rel="icon" type="image/x-icon" href={s3baseUrl + favIcon} />
            </Helmet>
            <ChatContext>
              <Routers />
            </ChatContext>
          </SnackbarProvider>
        </ThemeConfig>
      </ContextPGIMode>
    </QueryClientProvider>
  );
}
